import React, { ReactElement } from 'react';

import type { CompanyInterface } from 'interfaces/company.interface';
import CompanyViewInfoMetadataContent from 'components/company-view/company-view-info/metadata/content/content';

import './metadata.desktop.scss';

const CompanyViewInfoMetadataDesktop: React.FC<{ company: CompanyInterface; }> = ({ company }): ReactElement => (
    <div className="company-view-info__metadata">
        <CompanyViewInfoMetadataContent company={company} />
    </div>
);

export default CompanyViewInfoMetadataDesktop;
